export default __webpack_public_path__ + "static/media/ows.bd336a5a.svg";